/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains announcement text for web
 */
export const announcementContextKey = "announcement";
